import React from "react";
import PropTypes from "prop-types";
import { VideoPlayer, VIDEO_TYPE } from "../../components/VideoPlayer";

const VideoPlayerConnector = ({ data }) => (
	<VideoPlayer
		type={VIDEO_TYPE.CLOUDINARY}
		lang={data.node_locale.toLowerCase().substring(0, 2)}
		videoId={data?.video?.[0]?.public_id}
		posterUrl={data?.posterUrl?.[0]?.secure_url}
	/>
);

VideoPlayerConnector.propTypes = {
	data: PropTypes.shape({
		video: PropTypes.arrayOf(
			PropTypes.shape({
				secure_url: PropTypes.string.isRequired,
				public_id: PropTypes.string.isRequired,
			}).isRequired
		).isRequired,
		posterUrl: PropTypes.arrayOf(
			PropTypes.shape({
				secure_url: PropTypes.string.isRequired,
			}).isRequired
		).isRequired,
		node_locale: PropTypes.string.isRequired,
	}).isRequired,
};

export default VideoPlayerConnector;
export { VideoPlayerConnector };
